<template>
  <div class="bargain-container" ref="bargainContainer">
    <div class="bargain-list">
      <div class="header"></div>
      <div 
        class="list"
        v-if="bargainList.length > 0"
        >
          <div
            data-url="/pages/activity/goods_bargain_details/index?id=&bargain="
            class="item acea-row row-between-wrapper"
            hover-class="none"
            @click="openSubscribe(item.id)"
            v-for="(item,index) in bargainList"
            :key="index"
          >
            <div class="pictrue">
              <img :src="item.image" lazy-load="true">
              </div>
            <div class="text acea-row row-column-around">
              <div class="line1">{{item.title}}</div>
              <div class="num">
                <i class="iconfont icon-pintuan">{{item.people}}</i>人正在参与
              </div>
              <div class="money font-color">
                最低: ￥<span class="price">{{item.min_price}}</span>
              </div>
            </div>
            <div class="cutBnt">
              <span class="iconfont icon-kanjia"></span>去砍价
            </div>
          </div>
      </div>
      <div 
        v-else
        class="list">
        <div class="noCommodity" >
        <div class="pictrue">
          <img
            src="@assets/images/noGood.png"
          >
        </div>
      </div>
      </div>
    </div>
    <!-- 我的砍价 -->
    <div class="bargain_btn btn_link_fixed" @click="userBargainList">
      <div
        class="bargain_btn_child"
        url="/pages/activity/user_goods_bargain_list/index"
        ><span class="iconfont icon-kanjia"></span> 我的砍价</div>
    </div>
    <!-- 底部加载 -->
    <!-- <loading loading="">加载中</loading> -->
  </div>
</template>
<script>
import {getBargainList} from "@api/activity";
import { getUserInfo } from "@api/user";
export default {
  name: "GoodsBargain",
  data(){
    return{
      limit:10,
      page:1,
      loading:false,
      loadend:false,
      bargainList:[],
      userInfo:{}
    }
  },
  mounted(){
    this.getBargainList();
    this.getUserInfo();
    this.$scroll(this.$refs.bargainContainer,() => {
      !this.loading && this.getBargainList();
    })
  },
  methods:{
    getBargainList(){
      let that = this;
      if (that.loadend) return;
      if (that.loading) return;
      that.loading = true;
      let parame = {
        page : this.page,
        limit : this.limit
      }
      getBargainList(parame).then(res => {
        if(res.data.length == 0) return that.$dialog.message("目前暂无砍价活动");
        that.loadend = that.limit > res.data.length;
        that.bargainList = that.bargainList.concat(res.data)
        that.page++;
        that.loading = false;
      }).catch(res =>{
        that.loading = false;
      })
    },
    getUserInfo(){ //获取用户信息
      let that = this;
      getUserInfo().then(res => {
        that.userInfo = res.data;
      })
    },
    openSubscribe(id){
      this.$router.push({
        path:`/activity/goods_bargain_details?id=${id}&bargain=${this.userInfo.uid}`
      })
    },
    userBargainList(){
      this.$router.push({
        path:`/activity/user_goods_bargain_list`
      })
    }
  }
};
</script>

<style scoped>
.bargain-container{
  background: url("../../assets/images/tenBg.png") center top / 100% no-repeat;
  background-color:#FEFAF0!important;
  /* padding-bottom: 6.3rem; */
  min-height: 100vh;
}

.bargain-list .header {
  width: 7.5rem;
  height: 7.3rem;
}
.bargain-list .list {
  background-color: #fde6d9;
  border-radius: 10px;
  margin: 0 .3rem .4rem;
  padding: .18rem;
  border-color: transparent;
}
.bargain-list .list .item {
  border-radius: 10px;
  border-bottom: none;
  position: relative;
  height: 1.85rem;
  padding: .13rem;
  background: rgb(255, 255, 255,.5);
  margin-bottom: .23rem;
}
.bargain-list .list .item .pictrue {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 5px;
  overflow: hidden;
}
.bargain-list .list .item .pictrue image {
  width: 100%;
  height: 100%;
  border-radius: 3px;
}
.bargain-list .list .item .text {
  width: 4.5rem;
  font-size: .3rem;
  color: #282828;
  height: 1.6rem;
  padding-left: .3rem;
}
.bargain-list .list .item .text .num {
  font-size: .26rem;
  color: rgba(0, 0, 0, 0.2);
}
.bargain-list .list .item .text .num .iconfont {
  font-size: .26rem;
  margin-right: .07rem;
}
.bargain-list .list .item .text .money {
  font-size: .24rem;
  font-weight: bold;
  color: #fc364e;
}
.bargain-list .list .item .text .money .price {
  font-size: .42rem;
}
.bargain-list .list .item .text .line1 {
  /* width: 4.5rem; */
}
.bargain-list .list .item .cutBnt {
  position: absolute;
  width: 1.65rem;
  border-radius: 5px;
  font-size: .28rem;
  text-align: center;
  line-height: .5rem;
  right: .24rem;
  bottom: .23rem;
  background: linear-gradient(#fedfce, #fc9359);
  box-shadow: none;
  transform: skewX(-6deg);
  color: #000;
  font-weight: 700;
}
.bargain-list .list .item .cutBnt .iconfont {
  margin-right: .08rem;
  font-size: .3rem;
  font-weight: 500;
}
.bargain-list .list .load {
  font-size: .24rem;
  height: .85rem;
  text-align: center;
  line-height: .85rem;
}
/* ackerman 2021.1.5 */
.bargain_btn {
  height: 1rem;
  line-height: 1rem;
  color: #1a1818;
  border-radius: 8px;
  text-align: center;
  margin: 0 .3rem;
  z-index: 79;
  background: linear-gradient(#fde6d9, #f7c1a3);
  box-shadow: none !important;
  font-weight: 700;
}
.bargain_btn span{
  font-weight: 500;
}
.noCommodity .pictrue{
  width: 4.14rem;
  height: 3.36rem;
  margin: .2rem auto .3rem auto;
}
.noCommodity .pictrue img{
  width: 100%;
  height: 100%;
}
.noCommodity{
  padding-top: 0;
}
</style>
